import gsap from 'gsap'

function siteHeader() {
    const header = document.querySelector('[data-name="site-header"]')

    if (!header) return

    const menuButton = header.querySelector('[data-name="menu-button"]')
    const menu = header.querySelector('[data-name="main-menu"]')
    const topMenu = header.querySelector('[data-name="top-menu"]')
    const menuItems = menu.querySelectorAll('li.menu-item-has-children')
    const searchTrigger = header.querySelector('[data-name="search-trigger"]')
    const searchForm = header.querySelector('[data-name="search-form"]')
    const searchButton = searchForm.querySelector('[data-name="search-button"]')

    if (window.innerWidth < 1115) {
        menuButton.addEventListener('click', () => {
            document.body.classList.toggle('overflow-hidden')
            document.documentElement.classList.toggle('overflow-hidden')

            menu.classList.toggle('close-menu')
            topMenu.classList.toggle('close-menu')
            menu.classList.toggle('open-menu')
            topMenu.classList.toggle('open-menu')

            header.classList.toggle('bg-transparent')
            header.classList.toggle('bg-ink')
            header.classList.toggle('pointer-events-none')
            header.classList.toggle('pointer-events-auto')

            menuButton.getAttribute('aria-expanded') === 'true'
                ? menuButton.setAttribute('aria-expanded', 'false')
                : menuButton.setAttribute('aria-expanded', 'true')
        })

        menuItems.forEach((item) => {
            if (item.classList.contains('current-page-ancestor')) {
                openSubMenu(item)
            }

            item.firstElementChild.addEventListener('click', () => {
                openSubMenu(item)
            })
        })
    }

    gsap.set(searchForm, {
        width: '0px',
        marginLeft: '-15px',
        opacity: 0,
        pointerEvents: 'none',
    })

    searchTrigger.addEventListener('click', () => {
        toggleSearchForm()
    })

    function openSubMenu(item) {
        const subMenu = item.querySelector('.sub-menu-wrap')

        if (subMenu) {
            const backMenu = item.querySelector('.back-menu')

            subMenu.classList.toggle('open-sub-menu')

            if (backMenu) {
                backMenu.addEventListener('click', () => {
                    subMenu.classList.remove('open-sub-menu')
                })
            }
        }
    }

    function toggleSearchForm() {
        gsap.to(searchForm, {
            duration: 0.5,
            ease: 'power2.inOut',
            width: '200px',
            marginLeft: '20px',
            opacity: 1,
            pointerEvents: 'auto',
            onComplete: () => {
                searchTrigger.addEventListener('click', closeSearchForm)
                searchForm.focus()
            },
        })
    }

    function closeSearchForm() {
        searchForm.blur()
        gsap.to(searchForm, {
            duration: 0.5,
            ease: 'power2.inOut',
            width: '0px',
            marginLeft: '-15px',
            opacity: 0,
            pointerEvents: 'none',
            onComplete: () => {
                searchTrigger.removeEventListener('click', closeSearchForm)
            },
        })
    }
}
export default siteHeader
